import { useEffect, useState } from 'react';

import { SessionContext } from 'src/contexts';
import { authRefreshToken } from 'src/pages/auth/auth.axios.instance/';
import { Session, INITIAL_SESSION } from 'src/contexts/session.context/session.context.model';

const SessionContextProvider: React.FC = props => {
  const [sessionState, setSessionState] = useState(INITIAL_SESSION);
  const defaultSessionContext: [Session, typeof setSessionState] = [sessionState, setSessionState];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authRefreshToken({ onFinish: () => setLoading(false), setSessionState });
  }, [sessionState.isAuthenticated]);

  return (
    <SessionContext.Provider value={defaultSessionContext}>
      {loading ? null : props.children}
    </SessionContext.Provider>
  );
};

export default SessionContextProvider;
